import React from 'react';
import { IconProps } from '../types/types';

const PYPL: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#F0F3FA" d="M0 0h18v18H0z"/><path d="M12.68 6.3c0 1.24-1.24 2.7-3.12 2.7h-1.8l-.1.52L7.26 12H5l1.35-8H10c1.22 0 2.19.63 2.54 1.5a2 2 0 0 1 .15.8Z" fill="#002991"/><path d="M13.97 8.6c-.12.67-.5 1.28-1.06 1.72-.56.44-1.27.68-2.01.68H9.64l-.52 3H6.9l.36-2 .42-2.48.09-.52h1.8c1.87 0 3.12-1.46 3.12-2.7.92.44 1.46 1.32 1.3 2.3Z" fill="#60CDFF"/><path d="M12.68 6.3c-.39-.19-.86-.3-1.37-.3H8.27l-.51 3h1.8c1.87 0 3.12-1.46 3.12-2.7Z" fill="#008CFF"/></svg>
);

export default PYPL;